export const frRoles = {
    'collaboratorRoles.navbar': 'Rôles',
    'collaboratorRoles.name': 'Rôle',
    'collaboratorRoles.title': 'Rôles',

    //* COLLABORATOR LIST
    'collaboratorRoles.list.pageTitle': 'Rôles',
    'collaboratorRoles.list.actions.addRole': 'Créer un rôle',
    'collaboratorRoles.list.table.emptyLabel': "Il n'y a pas de rôle pour le moment",

    'collaboratorRoles.list.table.header.info': 'Roles',

    //* COLLABORATOR INFORMATIONS
    'collaboratorRoles.info.description': 'Saisissez ici la description du rôle',

    //* COLLABORATOR >> CREATE AND DETAILS
    'collaboratorRoles.create.pageTitle': 'Création rôle',
    'collaboratorRoles.details.pageTitle': 'Détails rôle',
    'collaboratorRoles.details.actions.previous': 'Rôles',

    'collaboratorRoles.info.title': 'Titre de rôle',
    'collaboratorRoles.info.input.title': 'Saisissez ici le titre du rôle *',
    'collaboratorRoles.info.code': 'Code',
    'collaboratorRoles.info.input.code': 'Saisissez ici le code du rôle',

    'collaboratorRoles.remove.dialog.title': 'Suppression du rôle',
    'collaboratorRoles.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce rôle ?',

    //* COLLABORATOR SHOPS
    'collaboratorRoles.shops.role.title': 'Liste centres en tant que {role}',

    //* COLLABORATOR AUDIENCES

    'collaboratorRoles.audiences.def.type.shop.title': '1 résultat attendu par centre',
    'collaboratorRoles.audiences.def.type.shop.subtitle': '(Seul un responsable peut répondre)',

    'collaboratorRoles.audiences.def.selectRoles': 'Sélectionnez les rôles des collaborateurs : ',
    'collaboratorRoles.audiences.noCustom.def.selectRoles':
        'Ce contenu doit être destiné à des collaborateurs spécifiques. Sélectionner les rôles des collaborateurs destinataires du contenu :',

    //* PERMISSIONS //* NOT USED
    'backofficeUsers.create.tabs.permissions.sectionTabs.rôles': 'Rôles',
    'backofficeUsers.permissions.collaboratorRoles.contentcreate':
        'Création de rôle',

    //* USER LIST
    'users.list.rowCell.manyRoles': '{description}, +{count}',

    //* TOAST
    'toast.apiErrors.UNABLE_TO_DELETE_USED_ROLE':
        'Ce rôle possède des collaborateurs et ne peut être supprimé',

    'toast.apiErrors.CAN_NOT_CHANGE_AUDIENCE_TARGET':
        'Il est impossbile de changer de type de public cible après la publication',
};
